import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["truncated", "longtext"]

  show(event){
    this.longtextTarget.classList.remove("hidden");
    this.positionTooltip(event);
  }

  hide() {
    this.longtextTarget.classList.add("hidden");
  }

  positionTooltip(event) {
    const tooltip = this.longtextTarget;
    let top = event.clientY + 10;
    let left = event.clientX + 10;

    tooltip.style.position = "fixed";
    tooltip.style.top = `${top}px`;
    tooltip.style.left = `${left}px`;

    const tooltipRect = tooltip.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    if (tooltipRect.bottom > viewportHeight) {
      top = event.clientY - tooltipRect.height - 10;
      tooltip.style.top = `${top}px`;
    }

    if (tooltipRect.right > viewportWidth) {
      left = event.clientX - tooltipRect.width - 10;
      tooltip.style.left = `${left}px`;
    }

    if (tooltipRect.top < 0) {
      tooltip.style.top = "10px";
    }
    if (tooltipRect.left < 0) {
      tooltip.style.left = "10px";
    }
  }
}
